<script setup>
import Icon from '@/components/Icon.vue';

const props = defineProps({
  title: { type: String, required: true },
  icon: { type: String, required: true },
  cards: { type: Array, required: true }, // [{ icon, title, body }]
});
</script>

<template>
  <div
    id="tldr"
    class="bg-gradient-to-b from-[#1c4848] to-[#123030] p-8 sm:p-12 rounded-[2rem] shadow-[0_20px_40px_rgb(28,72,72,0.15)] relative overflow-hidden group mb-20 animate-float border border-[#1c4848]"
  >
    <div class="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10 mix-blend-overlay"></div>
    <div class="absolute -top-24 -right-24 w-64 h-64 bg-[#ecd79f]/10 rounded-full blur-[60px] pointer-events-none group-hover:bg-[#ecd79f]/20 transition-colors duration-700"></div>

    <div class="relative z-10">
      <h2 class="text-2xl font-serif text-white font-medium mb-8 tracking-tighter flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center border border-white/10 backdrop-blur-md">
          <Icon :icon="props.icon" class="text-[#ecd79f] text-xl" />
        </div>
        {{ props.title }}
      </h2>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div
          v-for="(card, idx) in props.cards"
          :key="idx"
          class="bg-white/[0.03] hover:bg-white/[0.06] transition-colors duration-300 backdrop-blur-xl rounded-2xl p-6 border border-white/5"
        >
          <Icon :icon="card.icon" class="text-xl text-[#ecd79f] mb-4" />
          <h4 class="text-white/90 font-medium text-sm mb-2">{{ card.title }}</h4>
          <p class="text-white/50 text-xs font-normal leading-relaxed">{{ card.body }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

